// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill';
import 'url-polyfill';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import axios from 'axios';
import Meta from 'vue-meta';
import { ClientTable } from 'vue-tables-2';
import * as ModalDialogs from 'vue-modal-dialogs';
import App from './App';
import './plugins';
import router from './router';
import store from './store';
import config from './config/environment-config';
import i18n from './plugins/i18n';
import Paginate from 'vuejs-paginate';
import VTooltip from 'v-tooltip';

Vue.use(ModalDialogs);
Vue.use(VueCookie);
Vue.use(ClientTable);
Vue.use(Meta);
Vue.use(VTooltip);
Vue.prototype.$http = axios;
Vue.prototype.$eventBus = new Vue();

Vue.component('paginate', Paginate);

axios.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (
			error.response &&
			error.response.data &&
			(error.response.data.ErrorCode === '000-401-0000' ||
				error.response.data.ErrorCode === '000-401-0002' ||
				error.response.data.code === '001-401-0001')
		) {
			const accountBase = config[process.env.NODE_ENV][environment.region].account,
				currentDestination = encodeURIComponent(window.location.href);
			window.location = `${accountBase}/login?return_url=${currentDestination}`;
		}
		return Promise.reject(error);
	}
);

Vue.mixin({
	props: {
		locale: {
			type: String,
			default: '',
		},
	},
	created() {
		if (this.locale) {
			this.$i18n.locale = this.locale;
		}
	},
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	i18n,
	router,
	store,
	components: { App },
	data() {
		return {
			getData: {},
			error: {},
			totalPaymentAmount: null,
			afterBalanceWithRequirePayment: null,
		};
	},
	mounted() {
		this.$a2s.init();
		this.setCookie();
	},
	methods: {
		setCookie() {
			const prodId = this.$route.query.product_id;
			if (prodId) {
				this.$cookie.set('CommerceProdId', prodId, { expires: '30m' });
				this.$store.commit('setProductId', prodId);
			}
		},
	},
	render: (h) => h(App),
});

// window.environment = process.env.NODE_ENV;
